//#region src/cookies/cookies-enum.ts
var e = /* @__PURE__ */ function(e) {
	return e.UserContextKey = "sio_u_public", e.BrowserSessionActiveId = "sio_browser_session_active_id", e;
}({});
//#endregion
export { e as CookiesEnum };
